import { render, staticRenderFns } from "./CrmLeadDetailHistoryApi.vue?vue&type=template&id=712de74f&lang=pug&"
import script from "./CrmLeadDetailHistoryApi.vue?vue&type=script&lang=js&"
export * from "./CrmLeadDetailHistoryApi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports